<template>
  <div
    :class="DS_PAGE_CLASSES.Root"
    data-cy="ds-page"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { DS_PAGE_CLASSES } from "../constants/classes";
</script>
